$(function () {
    function initAccordion(trigger, activeItemFirst, activeItemClass, allItemsHidden) {
        trigger.on('click', function H() {
            let self = $(this);
            trigger.not(self).siblings()
                .slideUp(400);
            self.parent().siblings().removeClass(`${activeItemClass}`);
            if (self.parent().hasClass(`${activeItemClass}`)) {
                self.siblings().slideUp(400);
                self.parent().removeClass(`${activeItemClass}`);
            } else {
                $(this).siblings()
                    .slideDown(400);
                $(this).parent().addClass(`${activeItemClass}`);
            }
        });

        if(allItemsHidden != true) {
            if (activeItemFirst) {
                activeItemFirst.first().find(trigger)
                    .siblings()
                    .slideDown(400);
                activeItemFirst.first().addClass(`${activeItemClass}`);
            }
        }
    }

    function initAccordionWithContainerClass(trigger, accordionContainerClass, activeItemFirst, activeItemClass, allItemsHidden) {
        $(document).on('click', trigger, function() {
            let self = $(this);
            let accordion = self.closest(`.${accordionContainerClass}`);

            accordion.find(trigger).not(self).siblings().slideUp(400, function() {
                $(this).parent().removeClass(activeItemClass);
            });

            if (self.parent().hasClass(activeItemClass)) {
                self.siblings().slideUp(400, function() {
                    self.parent().removeClass(activeItemClass);
                });
            } else {
                self.siblings().slideDown(400, function() {
                    self.parent().addClass(activeItemClass);
                });
            }
        });

        if (allItemsHidden !== true) {
            if (activeItemFirst) {
                let accordions = $(trigger).closest(`.${accordionContainerClass}`);
                accordions.each(function() {
                    let itemFirst = $(this).find(activeItemFirst).first();
                    itemFirst.first().find(trigger).siblings().slideDown(400, function() {
                        $(this).parent().addClass(activeItemClass);
                    });
                });
            }
        }
    }

    initAccordion($('.js-trigger-accordion'), $('.js-accordion-item'), 'active');
    initAccordion($('.js-trigger-sources'), $('.js-sources-item'), 'active', true);
    initAccordion($('.js-trigger-additional-resources'), $('.js-additional-resources-item'), 'active', true);
    initAccordion($('.js-trigger-img-acc'), $('.js-img-acc-item'), 'active');
    initAccordion($('.js-trigger-sources-acc'), $('.js-sources-acc-item'), 'active');
    initAccordion($('.js-trigger-retrieved-from-acc'), $('.js-trigger-retrieved-from-acc-item'), 'active', true);
    initAccordion($('.js-jl-trigger-accordion'), $('.js-jl-accordion-item'), 'active', true);

    initAccordionWithContainerClass('.js-taa-trigger-accordion', 'title-and-accordion', $('.js-taa-accordion-item'), 'active');

    if (window.matchMedia('(max-width: 767px)').matches) {
        initAccordion($('.js-scrolling-accordion-trigger'), $('.js-scrolling-accordion-item'), 'active', true);
    }

    const $imgAccMedia = $('.js-img-acc-media'),
        $imgAccTriggers = $('.js-trigger-img-acc');

    $imgAccMedia.hide();
    $imgAccMedia.filter('[data-img-acc-media="1"]').show();

    $imgAccTriggers.on('click', function() {
        let imgIndex = $(this).data('img-acc-media');
        $imgAccMedia.hide();
        $imgAccMedia.filter(`[data-img-acc-media="${imgIndex}"]`).fadeIn(400);
    });
});
